import React, { useEffect } from "react"
import config from "../config"

const TawkToChat = ({ handleClick }) => {
  useEffect(() => {
    const tawkToScript = document.createElement("script")
    tawkToScript.src = config.tawkToSrc
    tawkToScript.async = true
    document.body.appendChild(tawkToScript)

    return () => {
      document.body.removeChild(tawkToScript)
    }
  }, [])

  useEffect(() => {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.onChatStarted = function () {
      console.log("Chat started, send internal notification");
    };
    window.Tawk_API.onChatMessageVisitor = function (message) {
      console.log("Visitor sent message", message);
    };
  }, []);


  return <div>{/* This div will be replaced by the Tawk.to chat widget */}</div>
}

export default TawkToChat
